<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">
    <div class="vx-navbar-wrapper navbar-full p-0">
      <vs-navbar class="navbar-custom navbar-skelton" :class="navbarClasses" :style="navbarStyle" :color="navbarColor">

        <!-- <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" /> -->

        <router-link tag="div" to="/" class="vx-logo cursor-pointer mx-auto flex items-center p-0">
          <img class="p-0" :src="logoBase" height="45px" width="auto" />
        </router-link>

        <!-- <search-bar />

      <notification-drop-down /> -->

        <profile-drop-down />

      </vs-navbar>
    </div>
  </div>
</template>

<script>
import HNavMenu from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue";
import Bookmarks from "./components/Bookmarks.vue"
import SearchBar from "./components/SearchBar.vue"
import NotificationDropDown from "./components/NotificationDropDown.vue"
import ProfileDropDown from "./components/ProfileDropDown.vue"
import Logo from "../Logo.vue"
import axios from "@/axios.js";
export default {
  name: "the-navbar-horizontal",
  data: () => ({
    logoBase: "",
  }),
  props: {
    logo: { type: String },
    navbarType: {
      type: String,
      required: true
    }
  },
  components: {
    Logo,
    Bookmarks,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown,
  },
  computed: {
    navbarColor() {
      let color = "#fff"
      if (this.navbarType === "sticky") color = "#f7f7f7"
      else if (this.navbarType === 'static') {
        if (this.scrollY < 50) {
          color = "#f7f7f7"
        }
      }

      this.isThemedark === "dark" ? color === "#fff" ? color = "#10163a" : color = "#262c49" : null

      return color
    },
    isThemedark() { return this.$store.state.main.theme },
    navbarStyle() { return this.navbarType === "static" ? { transition: "all .25s ease-in-out" } : {} },
    navbarClasses() { return this.scrollY > 5 && this.navbarType === "static" ? null : "d-theme-dark-light-bg shadow-none" },
    scrollY() { return this.$store.state.main.scrollY },
    verticalNavMenuWidth() { return this.$store.state.main.verticalNavMenuWidth },
    windowWidth() { return this.$store.state.main.windowWidth },
  }, mounted() {
    this.logoBase = axios.defaults.baseURL + "/storage/" + this.logo;
  },
}

</script>

